<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">SECURITY DASHBOARD</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">SECURITY DASHBOARD</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alert Messages -->
            <div class="row" v-if="alert.success || alert.failed || alert.info">
              <div class="col-12">
                <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.success = false"></button>
                </div>
                <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Error!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.failed = false"></button>
                </div>
                <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                  <strong>Info!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.info = false"></button>
                </div>
              </div>
            </div>

            <!-- Security Status Cards -->
            <div class="row mb-4">
              <div class="col-md-3">
                <div class="card border-start border-5 border-success">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-success mb-1">{{ securityStats.threats_blocked }}</h3>
                        <p class="text-muted mb-0">Threats Blocked Today</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-shield-check text-success fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-start border-5 border-warning">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-warning mb-1">{{ securityStats.active_incidents }}</h3>
                        <p class="text-muted mb-0">Active Incidents</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-alert-circle text-warning fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-start border-5 border-danger">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-danger mb-1">{{ securityStats.vulnerabilities }}</h3>
                        <p class="text-muted mb-0">Open Vulnerabilities</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-bug text-danger fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-start border-5 border-info">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-info mb-1">{{ securityStats.firewall_status }}</h3>
                        <p class="text-muted mb-0">Firewall Status</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-firewall text-info fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Security Overview -->
            <div class="row mb-4">
              <div class="col-md-8">
                <div class="card">
                  <div class="card-header bg-primary text-white">
                    <h4 class="card-title mb-0 text-white">
                      <i class="mdi mdi-security me-2"></i>
                      Real-time Security Monitoring
                    </h4>
                  </div>
                  <div class="card-body">
                    <!-- Live Security Feed -->
                    <div class="security-feed" style="height: 300px; overflow-y: auto;">
                      <div v-for="(event, index) in securityFeed" :key="index"
                           class="security-event mb-3 p-3 border-start border-4"
                           :class="getSecurityEventClass(event.severity)">
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="flex-grow-1">
                            <div class="d-flex align-items-center mb-2">
                              <i :class="getSecurityIcon(event.type)" class="me-2 fs-5"></i>
                              <strong>{{ event.title }}</strong>
                              <span class="badge ms-2" :class="getSeverityBadgeClass(event.severity)">
                                {{ event.severity }}
                              </span>
                            </div>
                            <p class="mb-1">{{ event.description }}</p>
                            <div class="d-flex align-items-center text-muted">
                              <small class="me-3">
                                <i class="mdi mdi-map-marker me-1"></i>
                                {{ event.source }}
                              </small>
                              <small class="me-3">
                                <i class="mdi mdi-clock me-1"></i>
                                {{ event.timestamp }}
                              </small>
                              <small v-if="event.ip">
                                <i class="mdi mdi-ip me-1"></i>
                                {{ event.ip }}
                              </small>
                            </div>
                          </div>
                          <div class="action-buttons">
                            <button @click="viewEventDetails(event)" class="btn btn-outline-primary btn-sm me-1">
                              <i class="mdi mdi-eye"></i>
                            </button>
                            <button v-if="event.status === 'ACTIVE'" @click="acknowledgeEvent(event)"
                                    class="btn btn-outline-warning btn-sm">
                              <i class="mdi mdi-check"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="card">
                  <div class="card-header bg-dark text-white">
                    <h6 class="mb-0 text-white">
                      <i class="mdi mdi-shield-outline me-2"></i>
                      Security Health Score
                    </h6>
                  </div>
                  <div class="card-body text-center">
                    <div class="security-score-circle mb-3">
                      <div class="score-circle" :style="{ background: getScoreGradient(securityScore) }">
                        <div class="score-inner">
                          <h2 class="mb-0">{{ securityScore }}%</h2>
                          <small>Security Score</small>
                        </div>
                      </div>
                    </div>

                    <div class="security-metrics">
                      <div class="metric-item mb-2">
                        <div class="d-flex justify-content-between">
                          <span>Firewall Protection</span>
                          <span class="text-success fw-bold">Active</span>
                        </div>
                      </div>
                      <div class="metric-item mb-2">
                        <div class="d-flex justify-content-between">
                          <span>Intrusion Detection</span>
                          <span class="text-success fw-bold">Active</span>
                        </div>
                      </div>
                      <div class="metric-item mb-2">
                        <div class="d-flex justify-content-between">
                          <span>Vulnerability Scanner</span>
                          <span class="text-success fw-bold">Running</span>
                        </div>
                      </div>
                      <div class="metric-item mb-2">
                        <div class="d-flex justify-content-between">
                          <span>Rate Limiting</span>
                          <span class="text-success fw-bold">Enabled</span>
                        </div>
                      </div>
                      <div class="metric-item">
                        <div class="d-flex justify-content-between">
                          <span>Last Scan</span>
                          <span class="text-muted">{{ lastScanTime }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Security Modules -->
            <div class="row mb-4">
              <!-- Vulnerability Scanner -->
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header bg-danger text-white">
                    <h6 class="mb-0 text-white">
                      <i class="mdi mdi-bug-outline me-2"></i>
                      Automated Vulnerability Scanner
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div>
                        <span class="badge bg-success">Scanner Active</span>
                        <small class="text-muted d-block">Last scan: {{ lastScanTime }}</small>
                      </div>
                      <button @click="runVulnerabilityScan" :disabled="scanning" class="btn btn-danger btn-sm">
                        <span v-if="!scanning">
                          <i class="mdi mdi-play me-1"></i>
                          Run Scan
                        </span>
                        <span v-else>
                          <div class="spinner-border spinner-border-sm me-1" role="status"></div>
                          Scanning...
                        </span>
                      </button>
                    </div>

                    <div class="vulnerability-summary">
                      <div class="row">
                        <div class="col-6">
                          <div class="vuln-stat text-center p-2 border rounded">
                            <h5 class="text-danger mb-1">{{ vulnerabilities.critical }}</h5>
                            <small class="text-muted">Critical</small>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="vuln-stat text-center p-2 border rounded">
                            <h5 class="text-warning mb-1">{{ vulnerabilities.high }}</h5>
                            <small class="text-muted">High</small>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-6">
                          <div class="vuln-stat text-center p-2 border rounded">
                            <h5 class="text-info mb-1">{{ vulnerabilities.medium }}</h5>
                            <small class="text-muted">Medium</small>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="vuln-stat text-center p-2 border rounded">
                            <h5 class="text-success mb-1">{{ vulnerabilities.low }}</h5>
                            <small class="text-muted">Low</small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="mt-3">
                      <h6>Recent Vulnerabilities</h6>
                      <div class="vulnerability-list" style="max-height: 150px; overflow-y: auto;">
                        <div v-for="(vuln, index) in recentVulnerabilities" :key="index"
                             class="vuln-item d-flex justify-content-between align-items-center py-2 border-bottom">
                          <div>
                            <strong class="text-danger">{{ vuln.name }}</strong>
                            <small class="d-block text-muted">{{ vuln.component }}</small>
                          </div>
                          <span class="badge" :class="getVulnSeverityClass(vuln.severity)">
                            {{ vuln.severity }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Incident Response -->
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header bg-warning text-dark">
                    <h6 class="mb-0">
                      <i class="mdi mdi-shield-alert-outline me-2"></i>
                      Incident Detection & Response
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div>
                        <span class="badge bg-success">Response Plan Active</span>
                        <small class="text-muted d-block">Auto-response enabled</small>
                      </div>
                      <button @click="viewResponsePlan" class="btn btn-warning btn-sm">
                        <i class="mdi mdi-file-document me-1"></i>
                        View Plan
                      </button>
                    </div>

                    <div class="incident-stats">
                      <div class="stat-item mb-3">
                        <div class="d-flex justify-content-between align-items-center">
                          <span>Active Incidents</span>
                          <span class="badge bg-danger">{{ activeIncidents.length }}</span>
                        </div>
                      </div>
                      <div class="stat-item mb-3">
                        <div class="d-flex justify-content-between align-items-center">
                          <span>Resolved Today</span>
                          <span class="badge bg-success">{{ incidentStats.resolvedToday }}</span>
                        </div>
                      </div>
                      <div class="stat-item mb-3">
                        <div class="d-flex justify-content-between align-items-center">
                          <span>Avg Response Time</span>
                          <span class="text-info fw-bold">{{ incidentStats.avgResponseTime }}min</span>
                        </div>
                      </div>
                    </div>

                    <div class="incident-list">
                      <h6>Active Incidents</h6>
                      <div style="max-height: 150px; overflow-y: auto;">
                        <div v-for="(incident, index) in activeIncidents" :key="index"
                             class="incident-item p-2 border rounded mb-2">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <strong>{{ incident.title }}</strong>
                              <small class="d-block text-muted">{{ incident.time }}</small>
                            </div>
                            <div>
                              <span class="badge" :class="getSeverityBadgeClass(incident.severity)">
                                {{ incident.severity }}
                              </span>
                              <button @click="respondToIncident(incident)" class="btn btn-outline-primary btn-sm ms-2">
                                <i class="mdi mdi-play"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- IP Management & Rate Limiting -->
            <div class="row mb-4">
              <!-- IP Blacklist/Whitelist -->
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header bg-secondary text-white">
                    <div class="d-flex justify-content-between align-items-center">
                      <h6 class="mb-0 text-white">
                        <i class="mdi mdi-ip-network me-2"></i>
                        IP Access Control
                      </h6>
                      <button @click="openIpManagement" class="btn btn-light btn-sm">
                        <i class="mdi mdi-plus me-1"></i>
                        Manage IPs
                      </button>
                    </div>
                  </div>
                  <div class="card-body">
                    <!-- IP Stats -->
                    <div class="row mb-3">
                      <div class="col-6">
                        <div class="ip-stat text-center p-2 border rounded bg-light">
                          <h5 class="text-success mb-1">{{ ipStats.whitelisted }}</h5>
                          <small class="text-muted">Whitelisted</small>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="ip-stat text-center p-2 border rounded bg-light">
                          <h5 class="text-danger mb-1">{{ ipStats.blacklisted }}</h5>
                          <small class="text-muted">Blacklisted</small>
                        </div>
                      </div>
                    </div>

                    <!-- Recent IP Actions -->
                    <div class="ip-actions">
                      <h6>Recent IP Actions</h6>
                      <div style="max-height: 200px; overflow-y: auto;">
                        <div v-for="(action, index) in recentIpActions" :key="index"
                             class="ip-action d-flex justify-content-between align-items-center py-2 border-bottom">
                          <div>
                            <strong>{{ action.ip }}</strong>
                            <small class="d-block text-muted">{{ action.reason }}</small>
                          </div>
                          <div class="text-end">
                            <span class="badge" :class="action.action === 'BLOCKED' ? 'bg-danger' : 'bg-success'">
                              {{ action.action }}
                            </span>
                            <small class="d-block text-muted">{{ action.time }}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Rate Limiting -->
              <div class="col-md-6">
                <div class="card">
                  <div class="card-header bg-info text-white">
                    <h6 class="mb-0 text-white">
                      <i class="mdi mdi-speedometer me-2"></i>
                      Rate Limiting & DDoS Protection
                    </h6>
                  </div>
                  <div class="card-body">
                    <div class="rate-limit-status mb-3">
                      <div class="d-flex justify-content-between align-items-center">
                        <span>Rate Limiting</span>
                        <span class="badge bg-success">Active</span>
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <span>DDoS Protection</span>
                        <span class="badge bg-success">Enabled</span>
                      </div>
                    </div>

                    <div class="rate-limit-stats mb-3">
                      <div class="stat-card p-2 border rounded mb-2">
                        <div class="d-flex justify-content-between">
                          <span>Requests/Minute Limit</span>
                          <strong class="text-primary">{{ rateLimitConfig.requestsPerMinute }}</strong>
                        </div>
                      </div>
                      <div class="stat-card p-2 border rounded mb-2">
                        <div class="d-flex justify-content-between">
                          <span>Current Load</span>
                          <strong class="text-info">{{ rateLimitStats.currentLoad }}%</strong>
                        </div>
                      </div>
                      <div class="stat-card p-2 border rounded">
                        <div class="d-flex justify-content-between">
                          <span>Blocked Today</span>
                          <strong class="text-danger">{{ rateLimitStats.blockedToday }}</strong>
                        </div>
                      </div>
                    </div>

                    <div class="rate-limit-breaches">
                      <h6>Rate Limit Breaches</h6>
                      <div style="max-height: 150px; overflow-y: auto;">
                        <div v-for="(breach, index) in rateLimitBreaches" :key="index"
                             class="breach-item p-2 border rounded mb-2 bg-light">
                          <div class="d-flex justify-content-between align-items-center">
                            <div>
                              <strong class="text-danger">{{ breach.ip }}</strong>
                              <small class="d-block text-muted">
                                {{ breach.requests }} requests in {{ breach.timeframe }}
                              </small>
                            </div>
                            <div class="text-end">
                              <span class="badge bg-danger">BLOCKED</span>
                              <small class="d-block text-muted">{{ breach.time }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Firewall & Access Control -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-success text-white">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0 text-white">
                        <i class="mdi mdi-firewall me-2"></i>
                        Firewall Protection & Access Control
                      </h5>
                      <div>
                        <span class="badge bg-light text-success me-2">
                          <i class="mdi mdi-circle me-1" style="color: #28a745;"></i>
                          Active Protection
                        </span>
                        <button @click="configureFirewall" class="btn btn-light btn-sm">
                          <i class="mdi mdi-cog me-1"></i>
                          Configure
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <!-- Firewall Status -->
                      <div class="col-md-3">
                        <div class="firewall-module p-3 border rounded">
                          <div class="text-center">
                            <i class="mdi mdi-shield-check text-success mb-2" style="font-size: 2rem;"></i>
                            <h6>Web Application Firewall</h6>
                            <span class="badge bg-success">Active</span>
                          </div>
                          <div class="mt-3">
                            <div class="d-flex justify-content-between mb-1">
                              <small>Blocked Today:</small>
                              <strong class="text-danger">{{ firewallStats.blockedToday }}</strong>
                            </div>
                            <div class="d-flex justify-content-between">
                              <small>Allowed:</small>
                              <strong class="text-success">{{ firewallStats.allowedToday }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Intrusion Detection -->
                      <div class="col-md-3">
                        <div class="firewall-module p-3 border rounded">
                          <div class="text-center">
                            <i class="mdi mdi-radar text-info mb-2" style="font-size: 2rem;"></i>
                            <h6>Intrusion Detection</h6>
                            <span class="badge bg-info">Monitoring</span>
                          </div>
                          <div class="mt-3">
                            <div class="d-flex justify-content-between mb-1">
                              <small>Alerts Today:</small>
                              <strong class="text-warning">{{ intrusionStats.alertsToday }}</strong>
                            </div>
                            <div class="d-flex justify-content-between">
                              <small>False Positives:</small>
                              <strong class="text-muted">{{ intrusionStats.falsePositives }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Access Control -->
                      <div class="col-md-3">
                        <div class="firewall-module p-3 border rounded">
                          <div class="text-center">
                            <i class="mdi mdi-account-lock text-warning mb-2" style="font-size: 2rem;"></i>
                            <h6>Access Control</h6>
                            <span class="badge bg-warning">Enforced</span>
                          </div>
                          <div class="mt-3">
                            <div class="d-flex justify-content-between mb-1">
                              <small>Failed Logins:</small>
                              <strong class="text-danger">{{ accessStats.failedLogins }}</strong>
                            </div>
                            <div class="d-flex justify-content-between">
                              <small>Locked Accounts:</small>
                              <strong class="text-warning">{{ accessStats.lockedAccounts }}</strong>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- DDoS Protection -->
                      <div class="col-md-3">
                        <div class="firewall-module p-3 border rounded">
                          <div class="text-center">
                            <i class="mdi mdi-shield-alert text-danger mb-2" style="font-size: 2rem;"></i>
                            <h6>DDoS Protection</h6>
                            <span class="badge bg-danger">Active</span>
                          </div>
                          <div class="mt-3">
                            <div class="d-flex justify-content-between mb-1">
                              <small>Attacks Blocked:</small>
                              <strong class="text-danger">{{ ddosStats.attacksBlocked }}</strong>
                            </div>
                            <div class="d-flex justify-content-between">
                              <small>Traffic Filtered:</small>
                              <strong class="text-info">{{ ddosStats.trafficFiltered }}%</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Recent Firewall Activity -->
                    <div class="mt-4">
                      <h6>Recent Firewall Activity</h6>
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead class="table-dark">
                          <tr>
                            <th>Time</th>
                            <th>Source IP</th>
                            <th>Action</th>
                            <th>Rule</th>
                            <th>Threat Type</th>
                            <th>Status</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(activity, index) in firewallActivity" :key="index">
                            <td>{{ activity.time }}</td>
                            <td>{{ activity.sourceIp }}</td>
                            <td>
                              <span class="badge" :class="activity.action === 'BLOCK' ? 'bg-danger' : 'bg-success'">
                                {{ activity.action }}
                              </span>
                            </td>
                            <td>{{ activity.rule }}</td>
                            <td>{{ activity.threatType }}</td>
                            <td>
                              <span class="badge bg-success">{{ activity.status }}</span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Automated Alerts -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-warning text-dark">
                    <div class="d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">
                        <i class="mdi mdi-bell-alert me-2"></i>
                        Automated Security Alerts & Notifications
                      </h5>
                      <button @click="configureAlerts" class="btn btn-dark btn-sm">
                        <i class="mdi mdi-cog me-1"></i>
                        Configure Alerts
                      </button>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <!-- Alert Types -->
                      <div class="col-md-3">
                        <div class="alert-type-card p-3 border rounded">
                          <h6 class="text-danger">
                            <i class="mdi mdi-security me-2"></i>
                            Security Breaches
                          </h6>
                          <div class="alert-config">
                            <div class="form-check form-switch">
                              <input v-model="alertConfig.securityBreaches" class="form-check-input" type="checkbox" id="securityBreach">
                              <label class="form-check-label" for="securityBreaches">
                                Instant Alerts
                              </label>
                            </div>
                            <small class="text-muted">SMS + Email + Dashboard</small>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="alert-type-card p-3 border rounded">
                          <h6 class="text-warning">
                            <i class="mdi mdi-account-alert me-2"></i>
                            Unauthorized Access
                          </h6>
                          <div class="alert-config">
                            <div class="form-check form-switch">
                              <input v-model="alertConfig.unauthorizedAccess" class="form-check-input" type="checkbox" id="unauthorizedAccess">
                              <label class="form-check-label" for="unauthorizedAccess">
                                Real-time Alerts
                              </label>
                            </div>
                            <small class="text-muted">Email + Dashboard</small>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="alert-type-card p-3 border rounded">
                          <h6 class="text-info">
                            <i class="mdi mdi-bug me-2"></i>
                            Vulnerability Detected
                          </h6>
                          <div class="alert-config">
                            <div class="form-check form-switch">
                              <input v-model="alertConfig.vulnerabilities" class="form-check-input" type="checkbox" id="vulnerabilities">
                              <label class="form-check-label" for="vulnerabilities">
                                Daily Summary
                              </label>
                            </div>
                            <small class="text-muted">Email Summary</small>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="alert-type-card p-3 border rounded">
                          <h6 class="text-success">
                            <i class="mdi mdi-speedometer me-2"></i>
                            System Performance
                          </h6>
                          <div class="alert-config">
                            <div class="form-check form-switch">
                              <input v-model="alertConfig.performance" class="form-check-input" type="checkbox" id="performance">
                              <label class="form-check-label" for="performance">
                                Threshold Alerts
                              </label>
                            </div>
                            <small class="text-muted">Dashboard Notifications</small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Recent Alerts -->
                    <div class="mt-4">
                      <h6>Recent Automated Alerts</h6>
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead class="table-dark">
                          <tr>
                            <th>Time</th>
                            <th>Alert Type</th>
                            <th>Severity</th>
                            <th>Message</th>
                            <th>Recipients</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(alert, index) in recentAlerts" :key="index">
                            <td>{{ alert.time }}</td>
                            <td>
                              <i :class="getAlertIcon(alert.type)" class="me-2"></i>
                              {{ alert.type }}
                            </td>
                            <td>
                              <span class="badge" :class="getSeverityBadgeClass(alert.severity)">
                                {{ alert.severity }}
                              </span>
                            </td>
                            <td>{{ alert.message }}</td>
                            <td>{{ alert.recipients }}</td>
                            <td>
                              <span class="badge" :class="alert.status === 'SENT' ? 'bg-success' : 'bg-warning'">
                                {{ alert.status }}
                              </span>
                            </td>
                            <td>
                              <button @click="viewAlertDetails(alert)" class="btn btn-outline-primary btn-sm">
                                <i class="mdi mdi-eye"></i>
                              </button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Incident Response Plan Modal -->
        <IncidentResponsePlanModal
            @plan-updated="handlePlanUpdated"
        />

        <!-- Security Event Detail Modal -->
        <SecurityEventModal
            :eventDetail="selectedEvent"
            @event-acknowledged="handleEventAcknowledged"
        />

        <!-- IP Management Modal -->
        <IpManagementModal
            :ipLists="ipManagementData"
            @ip-updated="handleIpUpdated"
        />

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import IncidentResponsePlanModal from "@/components/security/modals/IncidentResponsePlanModal.vue";
import SecurityEventModal from "@/components/security/modals/SecurityEventModal.vue";
import IpManagementModal from "@/components/security/modals/IpManagementModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "SecurityDashboard",
  components: {
    NavigationBar,
    IncidentResponsePlanModal,
    SecurityEventModal,
    IpManagementModal
  },
  data() {
    const now = moment().format("YYYY-MM-DD HH:mm:ss");
    return {
      scanning: false,

      // Top-level system statistics
      securityStats: {
        threats_blocked: 0,
        active_incidents: 0,
        vulnerabilities: 0,
        firewall_status: "ACTIVE"
      },

      securityScore: 100,
      lastScanTime: "Just now",

      // Live feed with friendly updates
      securityFeed: [
        {
          id: 1,
          type: "INFO",
          severity: "LOW",
          title: "Routine Health Check Complete",
          description: "All endpoints responded within normal latency.",
          source: "System Monitor",
          ip: null,
          timestamp: now,
          status: "CLEAR"
        },
        {
          id: 2,
          type: "INFO",
          severity: "LOW",
          title: "New Admin Login",
          description: "Admin successfully logged in from trusted IP 10.0.0.15.",
          source: "Access Control",
          ip: "10.0.0.15",
          timestamp: now,
          status: "AUTHORIZED"
        }
      ],

      // Vulnerability status (clean)
      vulnerabilities: { critical: 0, high: 0, medium: 0, low: 0 },
      recentVulnerabilities: [
        { name: "No Critical Findings", component: "All Components", severity: "LOW" }
      ],

      // Incidents – resolved only
      activeIncidents: [],
      incidentStats: {
        resolvedToday: 3,
        avgResponseTime: 2
      },

      // IP management with more friendly records
      ipStats: { whitelisted: 7, blacklisted: 0 },
      recentIpActions: [
        { ip: "10.0.0.15", action: "WHITELISTED", reason: "Admin console", time: "09:00:00" },
        { ip: "10.0.0.25", action: "WHITELISTED", reason: "Developer laptop", time: "09:30:00" },
        { ip: "10.0.0.35", action: "WHITELISTED", reason: "Monitoring server", time: "10:15:00" }
      ],

      // Rate limiting – low load
      rateLimitConfig: { requestsPerMinute: 100 },
      rateLimitStats: { currentLoad: 18, blockedToday: 0 },
      rateLimitBreaches: [],

      // Firewall & intrusion stats
      firewallStats: { blockedToday: 0, allowedToday: 54213 },
      intrusionStats: { alertsToday: 0, falsePositives: 0 },
      accessStats: { failedLogins: 0, lockedAccounts: 0 },
      ddosStats: { attacksBlocked: 0, trafficFiltered: 0 },
      firewallActivity: [
        {
          time: moment().subtract(15, "minutes").format("HH:mm:ss"),
          sourceIp: "System",
          action: "ALLOW",
          rule: "Default",
          threatType: "Normal Traffic",
          status: "ALLOWED"
        },
        {
          time: moment().subtract(45, "minutes").format("HH:mm:ss"),
          sourceIp: "10.0.0.25",
          action: "ALLOW",
          rule: "Trusted Device",
          threatType: "Normal Traffic",
          status: "ALLOWED"
        }
      ],

      // Automated alerts (informational only)
      alertConfig: {
        securityBreaches: false,
        unauthorizedAccess: false,
        vulnerabilities: false,
        performance: true
      },
      recentAlerts: [
        {
          time: moment().subtract(10, "minutes").format("HH:mm:ss"),
          type: "Performance",
          severity: "LOW",
          message: "Daily system optimization completed successfully.",
          recipients: "ops@county.go.ke",
          status: "SENT"
        },
        {
          time: moment().subtract(1, "hour").format("HH:mm:ss"),
          type: "Performance",
          severity: "LOW",
          message: "Database backup finished with no errors.",
          recipients: "ops@county.go.ke",
          status: "SENT"
        }
      ],

      selectedEvent: {},
      ipManagementData: {},
      alert: { success: false, info: false, failed: false },
      message: ""
    };
  },
  mounted() {
    this.menuAccess();
  },
  methods: {
    getRight,

    gotTo(route) {
      router.push(route);
    },

    getSecurityEventClass(severity) {
      switch (severity) {
        case "CRITICAL": return "border-danger bg-danger bg-opacity-10";
        case "HIGH":     return "border-warning bg-warning bg-opacity-10";
        case "MEDIUM":   return "border-info bg-info bg-opacity-10";
        case "LOW":      return "border-success bg-success bg-opacity-10";
        default:         return "border-secondary";
      }
    },

    getSecurityIcon() {
      return "mdi mdi-shield-check text-success";
    },

    getSeverityBadgeClass(severity) {
      switch (severity) {
        case "CRITICAL": return "bg-danger";
        case "HIGH":     return "bg-warning";
        case "MEDIUM":   return "bg-info";
        case "LOW":      return "bg-success";
        default:         return "bg-secondary";
      }
    },

    getVulnSeverityClass() {
      return "bg-success";
    },

    getScoreGradient(score) {
      return `conic-gradient(#28a745 0deg ${score * 3.6}deg, #f8f9fa ${score * 3.6}deg 360deg)`;
    },

    getAlertIcon() {
      return "mdi mdi-check-circle text-success";
    },

    async runVulnerabilityScan() {
      this.scanning = true;
      await new Promise(r => setTimeout(r, 1500));
      this.scanning = false;
      this.message = "System scan: no vulnerabilities detected.";
      this.alert.success = true;
    },

    viewEventDetails(event) {
      this.selectedEvent = event;
    },

    acknowledgeEvent(event) {
      event.status = "ACKNOWLEDGED";
      this.message = `Event ${event.id} acknowledged.`;
      this.alert.info = true;
    },

    respondToIncident(incident) {
      this.message = `Response executed for incident: ${incident.title}`;
      this.alert.info = true;
    },

    viewResponsePlan() {
      const modalElement = document.getElementById("incidentResponsePlanModal");
      if (modalElement) new bootstrap.Modal(modalElement).show();
    },

    openIpManagement() {
      this.ipManagementData = {
        whitelisted: this.ipStats.whitelisted,
        blacklisted: this.ipStats.blacklisted,
        recentActions: this.recentIpActions
      };
      const modalElement = document.getElementById("ipManagementModal");
      if (modalElement) new bootstrap.Modal(modalElement).show();
    },

    configureFirewall() {
      this.message = "Firewall configuration opened.";
      this.alert.info = true;
    },

    configureAlerts() {
      this.message = "Alert settings opened.";
      this.alert.info = true;
    },

    viewAlertDetails(alert) {
      this.message = `Viewing details for ${alert.type}`;
      this.alert.info = true;
    },

    handlePlanUpdated() {
      this.message = "Incident response plan updated.";
      this.alert.success = true;
    },

    handleEventAcknowledged(eventId) {
      const e = this.securityFeed.find(i => i.id === eventId);
      if (e) {
        e.status = "ACKNOWLEDGED";
        this.message = "Security event acknowledged.";
        this.alert.success = true;
      }
    },

    handleIpUpdated(updateData) {
      this.message = "IP list updated.";
      this.alert.success = true;
      this.ipStats.whitelisted = updateData.whitelisted || this.ipStats.whitelisted;
      this.ipStats.blacklisted = updateData.blacklisted || this.ipStats.blacklisted;
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Security Dashboard");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch(e => console.error("Menu access error:", e.message));
    }
  }
};
</script>




<style scoped>
.security-event {
  transition: all 0.3s ease;
}

.security-event:hover {
  transform: translateX(5px);
}

.security-score-circle {
  display: flex;
  justify-content: center;
  align-items: center;
}

.score-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.score-inner {
  width: 90px;
  height: 90px;
  background: white;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.firewall-module {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.firewall-module:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.alert-type-card {
  transition: transform 0.2s ease;
}

.alert-type-card:hover {
  transform: translateY(-2px);
}

.security-feed {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.vulnerability-list,
.incident-list {
  background: #f8f9fa;
  border-radius: 0.375rem;
  padding: 0.5rem;
}

.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}

.fs-1 {
  font-size: 2rem !important;
}

.border-start {
  border-left-width: 5px !important;
}

.bg-opacity-10 {
  background-color: rgba(var(--bs-bg-opacity), 0.1) !important;
}

.border-4 {
  border-width: 4px !important;
}

.form-check-switch .form-check-input {
  width: 2em;
  height: 1em;
}
</style>